import * as Sentry from '@sentry/browser'
import type { RouteLocationNormalizedGeneric } from 'vue-router'

const isPasswordSetRoute = (route: RouteLocationNormalizedGeneric) => {
  return route.hash.startsWith('#/password-set')
}
const ALLOWED_ROUTES: Array<string> = [
  'login',
  'redirect',
  'clerk-redirect',
  'logout',
  'logout-redirect',
  'forgot-password',
  'password-set-loginId-token',
  'book-bookingId'
]
const isPrivateRoute = (route: RouteLocationNormalizedGeneric) => {
  return !ALLOWED_ROUTES.includes(route.name as string)
}

export default defineNuxtRouteMiddleware(async (to) => {
  try {
    const { getEffectiveAuthToken } = useEffectiveAuthToken()
    if (isPasswordSetRoute(to)) {
      return navigateTo(to.hash.replace('#', ''))
    }
    const authToken = await getEffectiveAuthToken()
    if (!authToken && isPrivateRoute(to)) {
      return navigateTo({ path: '/login', query: to.query })
    }
  } catch (error) {
    Sentry.captureException(error)
    const snackbar = useSnackbar()
    snackbar.error('An error occurred during route authentication. Please try again.')
  }
})
